import { Entry } from '../Entry'

export function Entry20220826() {
  return (
    <Entry title="26/08/2022 - v3.2.2">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/12757/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
